export default {
  en: {
    'components.filing-outcome-form.inputVat.label': 'Input VAT',
    'components.filing-outcome-form.outputVat.label': 'Output VAT',

    'components.filing-outcome-form.inputVat.placeholder': 'Enter input VAT amount',
    'components.filing-outcome-form.outputVat.placeholder': 'Enter output VAT amount',

    'components.filing-outcome-form.inputVat.error': 'Please enter an input VAT amount',
    'components.filing-outcome-form.outputVat.error': 'Please enter an output VAT amount',

    'components.filing-outcome-form.fallback-error':
      'Error updating filing outcome, please try again.',
  },
};
